import React from "react";
import PropTypes from "prop-types";
import DataTable from "../../core/DataTable.jsx";
import { useHistory, Link } from "react-router-dom";
import Badge from "../../core/Badge.jsx";

const SprintTable = ({
  data,
  loading,
  recordsData,
  onPageChange,
  baseUrl,
  setSortParams,
  sortParams,
}) => {
  const history = useHistory();

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "300px",
      cell: (row) => (
        <Link
          className="table-link truncate"
          to={{ pathname: `/sprint/${row.sprint_id}` }}
        >
          {row.name}
        </Link>
      ),
    },
    {
      id: "is_active",
      name: "Status",
      selector: (row) => (row.is_active ? "Active" : "Completed"),
      sortable: true,
      width: "65px",
      cell: (row) => <Badge status={row.is_active} type="active" />,
    },
    {
      name: "Start Date",
      selector: (row) => new Date(row.start_date),
      sortable: true,
      width: "80px",
      cell: (row) => (
        <span>{new Date(row.start_date).toLocaleDateString()}</span>
      ),
    },
    {
      name: "End Date",
      selector: (row) => new Date(row.end_date),
      sortable: true,
      width: "80px",
      cell: (row) => <span>{new Date(row.end_date).toLocaleDateString()}</span>,
    },
    {
      name: "Progress",
      selector: (row) => row.progress || 0,
      sortable: true,
      width: "60px",
      cell: (row) => (
        <div className="progress" style={{ width: "100px" }}>
          <div
            className="progress-bar"
            role="progressbar"
            style={{ width: `${row.progress || 0}%` }}
            aria-valuenow={row.progress || 0}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {row.progress || 0}%
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="sprint-data-table">
      <DataTable
        columns={columns}
        data={data}
        loading={loading}
        onRowClick={(row) => history.push(`/sprint/${row.sprint_id}`)}
        onPageChange={onPageChange}
        recordsData={recordsData}
        baseUrl={baseUrl}
        noDataComponent="No sprints found"
        setSortParams={setSortParams}
        defaultSortFieldId={sortParams?.sortBy}
        defaultSortAsc={sortParams?.sortDir !== "desc"}
        isSortedManually={true}
      />
    </div>
  );
};

SprintTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      sprint_id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      project: PropTypes.shape({
        name: PropTypes.string,
      }),
      is_active: PropTypes.bool.isRequired,
      start_date: PropTypes.string.isRequired,
      end_date: PropTypes.string.isRequired,
      progress: PropTypes.number,
      totalTasks: PropTypes.number,
      completedTasks: PropTypes.number,
      totalPoints: PropTypes.number,
      completedPoints: PropTypes.number,
    })
  ).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default SprintTable;
